import api from '@services/api';
import { Cell } from '../models/cell';
import { CommonBasicRequest } from '../models/common';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all cell related CRUD calls
 */
export const cellApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    searchCell: builder.query<PaginationResponse<Cell>, CommonBasicRequest>({
      query: (params: CommonBasicRequest) => ({
        url: encodeURI(
          `/approvers/cell/search?searchTerm=${params.searchTerm}&bringAll=${params.bringAll}&page=${params.page}&size=${params.size}&sortKey=${params.sortKey}&sortDirection=ASC`,
        ),
      }),
      providesTags: ['Cell'],
    }),
  }),
});

export const { useSearchCellQuery } = cellApi;
